export const FavoriteIcon = ({
  className,
  selected,
}: {
  className: string;
  selected?: boolean;
}) => {
  return (
    <>
      {selected ? (
        <svg
          className={`stroke-current ${className}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.625 18.75a.625.625 0 01-.415-.156L10 13.96l-5.21 4.633a.625.625 0 01-1.04-.469V3.75a2.503 2.503 0 012.5-2.5h7.5a2.503 2.503 0 012.5 2.5v14.375a.625.625 0 01-.625.625z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <svg
          className={`stroke-current ${className}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.75 1.875h-7.5A1.875 1.875 0 004.375 3.75v14.375l5.625-5 5.625 5V3.75a1.875 1.875 0 00-1.875-1.875z"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
};
